import { useContext } from 'react';

import { RouteContext } from 'src/context';
import { STUDIO_POST_CREATE_VALUE } from 'src/routes/onboarding/setup/constants';
import {
  isOnboardingStep,
  isStudioStep,
  OnboardingQueryParams,
} from 'src/routes/onboarding/setup/types';

export const useOnboardingQueryParams = () => {
  const { query } = useContext(RouteContext);
  const {
    prefill_email,
    template_id,
    template_name,
    step,
    studio_step,
    studio_post_create,
    portal_header,
    portal_url,
    ...queryParams
  } = query as OnboardingQueryParams;

  return {
    prefillEmail:
      prefill_email !== undefined
        ? decodeURIComponent(prefill_email)
        : undefined,
    workspaceTemplateId: template_id,
    workspaceTemplateName: template_name,
    step: isOnboardingStep(step) ? step : undefined,
    studioStep: isStudioStep(studio_step) ? studio_step : undefined,
    studioPostCreate: studio_post_create === STUDIO_POST_CREATE_VALUE,
    portalHeader: portal_header,
    portalUrl: portal_url,
    ...queryParams,
  } as const;
};
